import React, {useState, useContext } from 'react';
import { makeStyles,  Grid, Tooltip, Modal, Backdrop, Box, CircularProgress } from "@material-ui/core";
import {Paper, Typography }from '@material-ui/core';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";

import TableFooter from "@material-ui/core/TableFooter";

import IconButton from "@material-ui/core/IconButton";

import TableRow from "@material-ui/core/TableRow";




import SearchIcon from '@material-ui/icons/Search';

import PrintIcon from '@material-ui/icons/Print';
import UserContext from '../../context/Globales/UserContext';
import DataTableDetalle from './DataTableDetalle';
import  Loading  from '../modales/Loading';
import ExportExcel from 'react-export-excel';
import BarraProgress from '../modales/BarraProgress';
import moment from 'moment';



const ExcelFile = ExportExcel.ExcelFile;
const ExcelSheet = ExportExcel.ExcelSheet;
const ExcelColumn = ExportExcel.ExcelColumn;







const useStyles = makeStyles((theme) => ({

  titulo: {
  backgroundColor: theme.palette.fondotitulos.main, 
  width: '100%',
  textAlign: 'center',  
  color: 'dark',

  },
  tituloDetalle: {
    textAlign: 'center',  
    color: 'dark',
    },
  table: {
    backgroundColor: theme.palette.greyFondo.main, 
    width: '100%',
    justifyContent: 'space-around',
    maxHeight: 350,
    marginTop: '10px'
  },
  column: {
    backgroundColor: theme.palette.fondotitulos.main,
    textAlign: 'center',
    color: 'dark'
  },

  details: {
    backgroundColor: theme.palette.fondotitulos.main,
  },
  mousePointer : {
    cursor: 'pointer',
    float: 'right', 
    paddingRight: '10px'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',       
  },
  papermodal: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 4),
    width: '65%',
    height: '650px'
  },

}));


const DataTableReistroConsulta = (dataFecha) => {


    const [ open, setOpen ] = useState(false);
    const [OpenLoading, setOpenLoading] = useState(false);
    const userContext = useContext(UserContext);
    const classes = useStyles();
    const fechaDesde = JSON.parse(localStorage.getItem('fechaInicio'))
    const fechaHasta = JSON.parse(localStorage.getItem('fechaTermino'))
    const sumaConsultas = JSON.parse(localStorage.getItem('sumaConsultas'));
    
    const Fecha1 = moment(fechaDesde).format('DD-MM-YYYY');
    const Fecha2 = moment(fechaHasta).format('DD-MM-YYYY');

    

    const { DataResumen } = useContext(UserContext);

    //OCUPARLO PARA EL EXCEL
    const { DataDetalle } = useContext(UserContext);




    //fn para modal pdf
    const handleOpen = () => {
      setOpen(true)
    }
    const handleClose = () => {
      setOpen(false);
    }

    //const usuarioDetalle = JSON.parse(localStorage.getItem("usuariosdetalle"))
   
 
    const handleDetalle = (user) => {

   //   console.log(user)
      setOpenLoading(true)
      userContext.getDetalleConsulta(user, fechaDesde, fechaHasta)

      handleOpen();

      setTimeout(() => {

        setOpenLoading(false)
        
                
    }, 4000);

    }

    // console.log(DataResumen);
const idrows = 0;
    return ( 
        <>   

      
      
         
         {DataResumen && DataResumen.resumen?.length > 0 ? (
        
        <Grid
          
          direction="column"
          justify="center"
          alignItems="center"                  
          >        
                    {/*tabla 1 */}   
               
        
          <TableContainer component={Paper} elevation={4} className={classes.table} >
        
              {/*Titulo y icono de salir */}

                <Typography style={{textAlign: 'center', fontWeight: 'bold', float: 'right'}} className={classes.titulo}>Informacion Consulta  
                </Typography>  

              <Table  stickyHeader aria-label="sticky table" size="large" >            
                      <TableHead  >
                        <TableRow >
                          {/*data[0] && columns.map((heading) => <th> {heading}  </th> )  me trae el nombre de las columnas segun el nombre que tienen en la bd*/}
                          <TableCell component="th" scope="row" align="center" className={classes.column}>
                            Usuario            
                          </TableCell>  
                          <TableCell component="th" scope="row" align="center" className={classes.column}>
                            Período Consultado          
                          </TableCell>
                          <TableCell component="th" scope="row" align="center" className={classes.column}>
                            Total Consultas
                          </TableCell>

                        </TableRow>
                      </TableHead>

                  <TableBody >
             
                 { DataResumen.resumen?.length <= 1 ? DataResumen.resumen?.map((itemm) => (
                    <TableRow hover > 
                    
                        <TableCell style={{width: '460'}} align="center">
                        { itemm.Usuario }             
                        </TableCell> 
                        
                        <TableCell style={{width: '460'}} align="center">
                        Desde: <b>{Fecha1}</b> Hasta: <b>{Fecha2}</b>             
                        </TableCell> 
                        <TableCell style={{width: '460'}} align="center">
                          {itemm.TotalConsultas}             
                        </TableCell> 
                        
                    </TableRow>
                  )) : (
                  <TableRow hover > 
                    
                  <TableCell style={{width: '460'}} align="center">
                  { "Todo los usuarios activos" }             
                  </TableCell> 
                  
                  <TableCell style={{width: '460'}} align="center">
                  Desde: <b>{Fecha1}</b> Hasta: <b>{Fecha2}</b>             
                  </TableCell> 
                  <TableCell style={{width: '460'}} align="center">
                    {DataResumen.resumen?.length > 1 && sumaConsultas }        
                  </TableCell> 
                  
              </TableRow>
                  
                  )}
                  </TableBody>

              </Table>
          </TableContainer>
        </Grid>

         ) : <h4>No se han encontrado resultados con el / los usuario(s) y fecha ingresada. (INTENTE DE NUEVO)</h4> }


        {/*tabla 2 */}  
        {DataResumen ? (
        <Grid
                direction="column"
                justify="center"
                alignItems="center"   
                             
                >                          
        <br />
        {!DataResumen ? <h4>Cargando información espere....</h4> : (

        <TableContainer component={Paper} elevation={3} className={classes.table}  >
        
       

            <Typography style={{textAlign: 'center', fontWeight: 'bold', float: 'right'}} className={classes.titulo}>Consultas Usuario 
            </Typography>  
          <Table   stickyHeader aria-label="sticky table" size="large" style={{textAlign: 'center' }} >            
          <TableHead  >
                        <TableRow >
                          {/*data[0] && columns.map((heading) => <th> {heading}  </th> )  me trae el nombre de las columnas segun el nombre que tienen en la bd*/}
                          <TableCell component="th" scope="row" align="center" className={classes.column}style={{width: '140px'}}>
                            Usuario Consultado             
                          </TableCell>  
                          <TableCell component="th" scope="row" align="center" className={classes.column}style={{width: '150px'}}>
                            Total Consultas
                          </TableCell>
                          <TableCell component="th" scope="row" align="center" className={classes.column} style={{width: '110px'}} >
                            Detalles
                          </TableCell>

                        </TableRow>
                      </TableHead>
            <TableBody>
              

            {DataResumen.resumen?.map((item, i) => (
              <TableRow hover > 

             <TableCell style={{width: '460'}} align="center">
             {item.Usuario }  
             
                     
             </TableCell> 
             <TableCell style={{width: '460'}} align="center">
             
            
            { item.TotalConsultas <= 20 ? <b style={{color: '#b3291d'}} >{item.TotalConsultas} </b> : <b style={{color: '#1cb954'}} >{item.TotalConsultas} </b>    }
          
            
                         
             </TableCell> 

             <TableCell style={{width: '460'}} align="center"> 
                                  
              <IconButton className={classes.details} onClick={()=>(
                handleDetalle(item.Usuario))} >  <SearchIcon/> </IconButton>            
              </TableCell> 
              </TableRow>
             ))} 
            </TableBody>
            <TableFooter>
          <TableRow>
            

          </TableRow>
        </TableFooter>
          </Table>
        </TableContainer>
        )}
        
</Grid>
  ): '' } 

  <Modal
        aria-labelledby="transition-modal-title"        
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
        timeout: 500,
        }}>

        <div className={classes.papermodal}>
        { DataDetalle && DataDetalle.detalles !== null ? 
          
          <Tooltip title="imprimir">
            <ExcelFile element={<IconButton className={classes.details} style={{float: 'right'}}> <PrintIcon/> </IconButton> }    filename={`Reporte consulta  ${Fecha1} al ${Fecha2}`} >
              <ExcelSheet data={DataDetalle.detalles} name={`Reporte consulta  ${Fecha1} ${Fecha2}`} >
                <ExcelColumn label="#" value={`${idrows}`}  />          
                <ExcelColumn label="Fecha Consulta" value="FechaConsulta" />
                <ExcelColumn label="Consulta Rut" value="RutConsulta" />
                <ExcelColumn label="Tipo Consulta " value="TipoConsulta" />               
              </ExcelSheet>
            </ExcelFile>     
          </Tooltip>
          : ' ' }

          <h2 id="transition-modal-title" className={classes.tituloDetalle} > Detalle de Usuarios </h2>

          <DataTableDetalle/>
         
        </div>
</Modal>


            
        </>
     );
}
 
export default DataTableReistroConsulta;